import {Consts} from "../pages/consts";
import {strengthUnits} from "../../resources/json/jsons";
import {useTranslation} from "react-i18next";
import Select from "react-select";
import {useState} from "react";
import {getInputFocusStyle} from "../pages/utils";

const strengthUnitSelectStyles = {
  container: (provided) => ({
    ...provided,
    width: "130px",
    minWidth: "130px",
    maxWidth: "140px",
  }),
  control: (provided) => ({
    ...provided,
    width: "130px",
    minWidth: "130px",
    maxWidth: "140px",
  }),
  menu: (provided) => ({
    ...provided,
    width: "130px",
    minWidth: "130px",
    maxWidth: "140px",
  }),
};

const StrengthAndStartDate = ({strength, onHandleStrength, strengthUnit, onHandleStrengthUnit, startDate,
                                onHandleStartDate}) => {
  const { t } = useTranslation();
  const [isStrengthFieldFocused, setIsStrengthFieldFocused] = useState(false);

  return(
    <div className="w3-row w3-padding-small w3-margin-top w3-margin-bottom strength-startdate-row">
      <div className="strength-startdate-group strength-startdate-group--strength">
        <div className="strength-startdate-label-col w3-left-align">
          <label>{t("strength")}*:</label>
        </div>
        <div className="strength-startdate-input-col">
          <input
            value={strength}
            type={Consts.NUMBER}
            min="0"
            onFocus={() => setIsStrengthFieldFocused(true)}
            onBlur={() => setIsStrengthFieldFocused(false)}
            className="form-input strength-startdate-number-input"
            onChange={(e) => onHandleStrength(e.target.value)}
            style={getInputFocusStyle(isStrengthFieldFocused)}
          />
        </div>
        <div className="strength-startdate-select-col">
          <Select
            id={Consts.STRENGTH_UNIT}
            value={strengthUnits?.filter(
              (option) => option?.value === strengthUnit,
            )}
            options={strengthUnits}
            formatOptionLabel={(o) => t(o?.label)}
            name={Consts.STRENGTH_UNIT}
            onChange={({ value }) => onHandleStrengthUnit(value)}
            placeholder={t("select")}
            className="custom-select-small strength-startdate-select"
            classNamePrefix="custom-select"
            styles={strengthUnitSelectStyles}
            isSearchable={false}
          />
        </div>
      </div>
      <div className="strength-startdate-group strength-startdate-group--date">
        <div className="strength-startdate-date-label-col">
          <label>{t("intake_start_date")}*</label>
        </div>
        <div className="strength-startdate-date-input-col">
          <input
            type="date"
            value={startDate}
            className="w3-input w3-border w3-round form-input strength-startdate-date-input"
            onChange={(e) => onHandleStartDate(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default StrengthAndStartDate;